import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f83bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slot-content" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { style: { display: 'inline-block', 'padding-right': '16px' } }
const _hoisted_4 = { style: { display: 'inline-block', 'padding-right': '16px' } }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Export ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add new client ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Change Sales Rep Group ")
const _hoisted_10 = { class: "data-table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Client", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Alias", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Email", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Client Type", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Commission Type", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "AssignedOn", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Transferred", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "client" }
const _hoisted_20 = { style: {"text-align":"center"} }
const _hoisted_21 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_new_client_modal = _resolveComponent("add-new-client-modal")!
  const _component_change_transferred_status_modal = _resolveComponent("change-transferred-status-modal")!
  const _component_recalculate_commissions_modal = _resolveComponent("recalculate-commissions-modal")!
  const _component_change_client_type_modal = _resolveComponent("change-client-type-modal")!
  const _component_change_client_manager_modal = _resolveComponent("change-client-manager-modal")!
  const _component_view_audit_modal = _resolveComponent("view-audit-modal")!
  const _component_change_sales_rep_group_modal = _resolveComponent("change-sales-rep-group-modal")!
  const _component_KDropDownList = _resolveComponent("KDropDownList")!
  const _component_KButton = _resolveComponent("KButton")!
  const _component_KSplitButton = _resolveComponent("KSplitButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_add_new_client_modal, {
        show: _ctx.showActionModal == 'addNewClient',
        "client-manager": _ctx.currentClientManager,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_change_transferred_status_modal, {
        show: _ctx.showActionModal == 'changeTransferredStatus',
        "client-manager": _ctx.currentClientManager,
        model: _ctx.actionModel,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "model", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_recalculate_commissions_modal, {
        show: _ctx.showActionModal == 'recalculateCommissions',
        "client-manager": _ctx.currentClientManager,
        model: _ctx.actionModel,
        "user-kind": 'client',
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "model", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_change_client_type_modal, {
        show: _ctx.showActionModal == 'changeClientType',
        "client-manager": _ctx.currentClientManager,
        model: _ctx.actionModel,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "model", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_change_client_manager_modal, {
        show: _ctx.showActionModal == 'changeClientManager',
        "client-manager": _ctx.currentClientManager,
        "client-manager-list": _ctx.clientManagerList,
        model: _ctx.actionModel,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "client-manager-list", "model", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_view_audit_modal, {
        show: _ctx.showActionModal == 'viewAudit',
        "client-manager": _ctx.currentClientManager,
        model: _ctx.actionModel,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "model", "onCloseModal", "onCommandExecuted"]),
      _createVNode(_component_change_sales_rep_group_modal, {
        show: _ctx.showActionModal == 'changeSalesRepGroup',
        "client-manager": _ctx.currentClientManager,
        onCloseModal: _ctx.onCloseModal,
        onCommandExecuted: _ctx.onCommandExecuted
      }, null, 8, ["show", "client-manager", "onCloseModal", "onCommandExecuted"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_KDropDownList, {
            value: _ctx.selectedClientManager,
            style: { width: '250px' },
            "data-items": _ctx.clientManagers,
            "text-field": 'FullName',
            "data-item-key": 'Id',
            onChange: _ctx.onSalesRepChanged
          }, null, 8, ["value", "data-items", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_KButton, {
            "icon-class": 'k-icon k-i-excel',
            onClick: _ctx.onExportClick
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_6,
          (_ctx.inAdminRole)
            ? (_openBlock(), _createBlock(_component_KButton, {
                key: 0,
                "icon-class": 'k-icon k-i-plus-circle',
                onClick: _ctx.onAddNewClient
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _hoisted_8,
          (_ctx.inAdminRole)
            ? (_openBlock(), _createBlock(_component_KButton, {
                key: 1,
                "icon-class": 'k-icon k-i-plus-circle',
                onClick: _ctx.onChangeSalesRepGroup
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              (_ctx.inAdminRole)
                ? (_openBlock(), _createElementBlock("th", _hoisted_18, " "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (client, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({ odd: index % 2 != 0 })
              }, [
                _createElementVNode("td", _hoisted_19, _toDisplayString(client.Client.toLocaleLowerCase()), 1),
                _createElementVNode("td", null, _toDisplayString(client.ClientAlias), 1),
                _createElementVNode("td", null, _toDisplayString(client.ClientEmail.toLocaleLowerCase()), 1),
                _createElementVNode("td", null, _toDisplayString(client.ClientType), 1),
                _createElementVNode("td", null, _toDisplayString(client.CommissionType), 1),
                _createElementVNode("td", null, _toDisplayString(client.AssignedOn), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(client.Transferred ? "Yes" : "No"), 1),
                (_ctx.inAdminRole)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_KSplitButton, {
                          "icon-class": 'k-icon k-i-gear',
                          "text-field": 'label',
                          items: _ctx.clientActions,
                          "fill-mode": 'flat',
                          onItemclick: ($event: any) => (_ctx.onActionClicked($event, client))
                        }, null, 8, ["items", "onItemclick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}